import React from 'react';
import { useSelectedSkuContext } from 'context/SelectedSku/SelectedSkuContext';
import { ProductPriceAmount } from 'types/Product';
import { getPriceWithSymbol } from 'utilities/price/price-utilities';
import VisiblyHidden from '../VisiblyHidden';
import { isNotInStock } from '../../utilities/util';

import styles from './DynamicPrice.module.css';

interface DynamicPriceProps {
  price: ProductPriceAmount;
  force?: boolean;
}

function DynamicPrice({ price, force = false }: DynamicPriceProps) {
  const { selectedSku, selectedInsurance, isInsuranceAvailable, filteredLinkedAddonServicesContent } =
    useSelectedSkuContext();
  const { currentFrom } = price;
  const getCurrentPriceText = () => {
    const basePrice = selectedSku?.price?.amount.current;
    const InsurancePrice = selectedInsurance?.offer?.sellingPrice;
    const addonPrices = filteredLinkedAddonServicesContent?.filter((x) => x.isSelected === true).map((x) => x.price);
    const totalAddonPrice = addonPrices?.reduce((acc, current) => acc + (current.now?.basePrice || 0), 0);

    const basePriceToNumber = selectedSku?.price?.amount.unformattedPrice;

    let total = basePriceToNumber;

    if (total) {
      total += totalAddonPrice ?? 0;
    }

    if (InsurancePrice && total) {
      total += InsurancePrice;
    }

    if (total) {
      return getPriceWithSymbol(total, price.currencyCode);
    }

    return basePrice;
  };
  const renderCurrent = () => {
    const text = getCurrentPriceText();
    const accessibilityText = text && `Total price ${text}`;

    return (
      <>
        <p className={styles.currentPrice} data-testid="dynamic-price" aria-hidden>
          {text}
        </p>

        <VisiblyHidden text={accessibilityText || ''} />
      </>
    );
  };

  return (currentFrom || isInsuranceAvailable || force) && selectedSku && !isNotInStock(selectedSku.stock?.code) ? (
    <div className={styles.container}>{renderCurrent()}</div>
  ) : null;
}

export default DynamicPrice;
